import FormCard from '@components/FormCard'
import { WhatsappBotSettingKey } from '@models/WhatsappBotSetting'
import { useAppDispatch } from '@store/hooks'
import { getWhatsappBotSettings } from '@store/WhatsappBotSettingReducer'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Permission } from '@utils/permissions'
import { Col, Divider, Flex, Image, Row } from 'antd'
import { useEffect } from 'react'
import { useHasAccess } from '../HasAccess'

export const SettingWhatsAppVenue = () => {
  const dispatch = useAppDispatch()
  const { hasAccess } = useHasAccess()

  useEffect(() => {
    dispatch(
      getWhatsappBotSettings([
        WhatsappBotSettingKey.BOOKING_BUTTON,
        WhatsappBotSettingKey.MANAGE_BOOKING_BUTTON,
        WhatsappBotSettingKey.MANAGE_BOOKING_FLOW_NO_UPCOMING_RESERVATION,
        WhatsappBotSettingKey.MORE_INFORMATION_BUTTON,
        WhatsappBotSettingKey.HOME_BUTTON,
        WhatsappBotSettingKey.MENU_BUTTON,
        WhatsappBotSettingKey.SHOW_MAP_BUTTON,
      ])
    )
  }, [])

  return (
    <Row gutter={[32, 32]}>
      <Col span={12}>
        <FormCard
          title="Booking button label"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.editSettingsPlatform)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.BOOKING_BUTTON,
            },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/book-button.png"
          />
        </Flex>
      </Col>
      <Divider />
      <Col span={12}>
        <FormCard
          title="Manage booking button label"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.editSettingsPlatform)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.MANAGE_BOOKING_BUTTON,
            },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/edit-cancel.png"
          />
        </Flex>
      </Col>
      <Divider />
      <Col span={12}>
        <FormCard
          title="No upcoming reservation message"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.editSettingsPlatform)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value:
                WhatsappBotSettingKey.MANAGE_BOOKING_FLOW_NO_UPCOMING_RESERVATION,
            },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/booking-not-found.png"
          />
        </Flex>
      </Col>
      <Divider />
      <Col span={12}>
        <FormCard
          title="More information button label"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.editSettingsPlatform)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.MORE_INFORMATION_BUTTON,
            },
          ]}
        />
      </Col>

      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/more-infos.png"
          />
        </Flex>
      </Col>
      <Divider />

      <Col span={12}>
        <FormCard
          title="Home button label"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.editSettingsPlatform)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.HOME_BUTTON,
            },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/home.png"
          />
        </Flex>
      </Col>
      <Divider />

      <Col span={12}>
        <FormCard
          title="Menus button label"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.editSettingsPlatform)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.MENU_BUTTON,
            },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/menus.png"
          />
        </Flex>
      </Col>
      <Divider />

      <Col span={12}>
        <FormCard
          title="Map button label"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          disabled={!hasAccess(Permission.editSettingsPlatform)}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.SHOW_MAP_BUTTON,
            },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300}
            width={378}
            src="/assets/whatsapp-templates/map.png"
          />
        </Flex>
      </Col>
      <Divider />
      {/*
      <Col span={12}>
        <FormCard
          title="Manage bookings button label"
          entity={Entity.whatsappBotSetting}
          action={SBRMAction.Update}
          metadata={[
            {
              key: MetadataKey.WhatsappBotSetting,
              value: WhatsappBotSettingKey.BOOKED_BUTTON,
            },
          ]}
        />
      </Col>
      <Col span={12}>
        <Flex className="w-full" justify="center">
          <Image
            height={300} width={378}
            src="/assets/whatsapp-templates/book-button.png"
          />
        </Flex>
      </Col> */}
    </Row>
  )
}

export type SettingWhatsAppVenueType = {
  SettingWhatsAppVenue: typeof SettingWhatsAppVenue
}
